import { render, staticRenderFns } from "./ConfigurationForm1110.vue?vue&type=template&id=2db440fa&scoped=true&lang=pug&"
import script from "./ConfigurationForm1110.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationForm1110.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationForm1110.vue?vue&type=style&index=0&id=2db440fa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db440fa",
  null
  
)

export default component.exports